import { WormholeService } from '@shared/services/wormhole/wormhole.service';
import { getEVMSigner } from '../signOrder/signWormholeEvm';
export async function executeEVMWormholeSwap({
  response,
  network,
  privateKey,
  signerConfig
}) {
  try {
    const wormhole = new WormholeService();
    const quoteResponse = response.quote.response;
    console.log(`----------- FETCHING WORMHOLE TOKEN TRANSFER -----------`, {
      networkIn: response.quote.networkIn,
      networkOut: response.quote.networkOut,
      tokenIn: response.quote.tokenIn,
      tokenOut: response.quote.tokenOut,
      slippage: quoteResponse.slippage,
      from: quoteResponse.from,
      recipient: quoteResponse.from,
      to: quoteResponse.to,
      amountIn: response.fees.netInputToken,
      orchestrate: false
    });
    const {
      tokenTransfer
    } = await wormhole.getWormholeTokenTransfer({
      networkIn: response.quote.networkIn,
      networkOut: response.quote.networkOut,
      tokenIn: response.quote.tokenIn,
      tokenOut: response.quote.tokenOut,
      slippage: quoteResponse.slippage,
      from: quoteResponse.from,
      recipient: quoteResponse.from,
      to: quoteResponse.to,
      amountIn: response.fees.netInputToken,
      orchestrate: false
    });
    console.log(`----------- FETCHING SIGNERS -----------`);
    const signer = await getEVMSigner(network, privateKey, signerConfig);
    console.log(`----------- SIGNERS FETCHED -----------`);
    const txIds = await tokenTransfer.initiateTransfer(signer);
    console.log('Transfer initiated, txIds:', txIds);
    return {
      txIds
    };
  } catch (error) {
    console.error('Error executing EVM Wormhole swap:', error);
    throw error;
  }
}